import { List, Package } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { POSBrowseMode } from './types';

interface BrowseModeToggleProps {
  mode: POSBrowseMode;
  onChange: (mode: POSBrowseMode) => void;
}

/**
 * Browse Mode Toggle - switches between All Items and Products mode
 */
export function BrowseModeToggle({ mode, onChange }: BrowseModeToggleProps) {
  return (
    <div className="flex items-center bg-muted rounded-sm p-1">
      <button
        onClick={() => onChange('all')}
        className={cn(
          'flex items-center gap-1.5 px-3 py-1.5 rounded-xs text-sm font-medium transition-colors',
          mode === 'all' ? 'bg-background shadow-sm' : 'text-muted-foreground hover:text-foreground'
        )}
      >
        <List className="w-4 h-4" />
        All Items
      </button>
      <button
        onClick={() => onChange('products')}
        className={cn(
          'flex items-center gap-1.5 px-3 py-1.5 rounded-xs text-sm font-medium transition-colors',
          mode === 'products'
            ? 'bg-background shadow-sm'
            : 'text-muted-foreground hover:text-foreground'
        )}
      >
        <Package className="w-4 h-4" />
        Products
      </button>
    </div>
  );
}
